import React, { useState } from 'react';

const LoginPage = () => {
    const [formData, setFormData] = useState({
        mobile_number: '',
        password: '',
        user_type: 'LOGISTICS',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const styles = {
        page: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #eef4ff 0%, #f8fbff 100%)',
            padding: '20px',
        },
        wrapper: {
            width: '100%',
            maxWidth: '980px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            background: '#ffffff',
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.12)',
        },
        leftPanel: {
            background: 'linear-gradient(135deg, #1f5eff 0%, #0f3fb8 100%)',
            color: '#ffffff',
            padding: '50px 35px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        brand: {
            fontSize: '14px',
            fontWeight: '700',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            opacity: 0.9,
            marginBottom: '18px',
        },
        leftTitle: {
            fontSize: '34px',
            fontWeight: '700',
            lineHeight: '1.25',
            margin: '0 0 16px 0',
        },
        leftText: {
            fontSize: '15px',
            lineHeight: '1.5',
            opacity: 0.92,
            margin: 0,
        },
        rightPanel: {
            padding: '50px 35px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            background: '#ffffff',
        },
        formHeader: {
            marginBottom: '28px',
        },
        formTitle: {
            fontSize: '30px',
            fontWeight: '700',
            color: '#1f2937',
            margin: '0 0 8px 0',
        },
        formSubTitle: {
            fontSize: '14px',
            color: '#6b7280',
            margin: 0,
        },
        errorBox: {
            background: '#fff1f2',
            border: '1px solid #fecdd3',
            color: '#be123c',
            fontSize: '14px',
            padding: '12px 14px',
            borderRadius: '10px',
            marginBottom: '18px',
        },
        formGroup: {
            marginBottom: '18px',
        },
        label: {
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
        },
        input: {
            width: '100%',
            height: '46px',
            border: '1px solid #d1d5db',
            borderRadius: '10px',
            padding: '0 14px',
            fontSize: '14px',
            color: '#111827',
            background: '#ffffff',
            boxSizing: 'border-box',
            outline: 'none',
        },
        button: {
            width: '100%',
            height: '48px',
            border: 'none',
            borderRadius: '10px',
            background: loading ? '#8fb1ff' : '#1f5eff',
            color: '#ffffff',
            fontSize: '15px',
            fontWeight: '700',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: '0.3s ease',
            marginTop: '8px',
        },
        footerText: {
            marginTop: '20px',
            fontSize: '12px',
            textAlign: 'center',
            color: '#9ca3af',
        },
        badgeRow: {
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            marginTop: '28px',
        },
        badge: {
            padding: '8px 12px',
            borderRadius: '999px',
            background: 'rgba(255,255,255,0.16)',
            border: '1px solid rgba(255,255,255,0.22)',
            fontSize: '12px',
            fontWeight: '600',
        },
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.mobile_number || !formData.password || !formData.user_type) {
            setError('Please fill all fields');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch('https://vials-api.nirnayanhealthcare.com/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (!response.ok) {
                setError(result.message || 'Login failed');
                return;
            }

            if (result?.status === 1) {
                localStorage.setItem('access_token', result.data.access_token);
                localStorage.setItem('user', JSON.stringify(result.data.user));

                if (result.data.user.user_type === 'ADMIN') {
                    window.location.href = '/admin';
                } else if (result.data.user.user_type === 'LOGISTICS') {
                    window.location.href = '/';
                }
            } else {
                setError(result?.message || 'Login failed');
            }
        } catch (err) {
            setError('Something went wrong while logging in');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.page}>
            <div className='newWrapper' style={styles.wrapper}>
                <div className='newLeftPanel' style={styles.leftPanel}>
                    <div style={styles.brand}>Nirnayan Healthcare</div>

                    <h1 className='title' style={styles.leftTitle}>
                        Logistics Vials
                        <br />
                        Tracking System
                    </h1>

                    <p className='paragraph' style={styles.leftText}>
                        Secure access for Admin and Logistics users to manage daily vial
                        collection entries, round tracking, dashboard review, and reporting.
                    </p>

                    <div className='badgeRowNew' style={styles.badgeRow}>
                        <div style={styles.badge}>Secure Login</div>
                        <div style={styles.badge}>Round Tracking</div>
                        <div style={styles.badge}>Admin Dashboard</div>
                    </div>
                </div>

                <div className='newRightPanel' style={styles.rightPanel}>
                    <div style={styles.formHeader}>
                        <h2 style={styles.formTitle}>Welcome Back</h2>
                        <p style={styles.formSubTitle}>
                            Sign in to continue to your account
                        </p>
                    </div>

                    {error ? <div style={styles.errorBox}>{error}</div> : null}

                    <form onSubmit={handleSubmit}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>User Type</label>
                            <select
                                name="user_type"
                                value={formData.user_type}
                                onChange={handleChange}
                                style={styles.input}
                            >
                                <option value="LOGISTICS">Logistics</option>
                                <option value="ADMIN">Admin</option>
                            </select>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Mobile Number</label>
                            <input
                                type="text"
                                name="mobile_number"
                                value={formData.mobile_number}
                                onChange={handleChange}
                                placeholder="Enter mobile number"
                                style={styles.input}
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter password"
                                style={styles.input}
                            />
                        </div>

                        <button type="submit" style={styles.button} disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>

                    <div style={styles.footerText}>
                        © 2026 Nirnayan Healthcare. All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;